import { SearchedLoyaltyProductViewDto, ViewLoyaltyProduct } from '@src/api';

import { LoyaltyStatus } from '../types';
import { LoyaltyProgramListProduct, LoyaltyProgramProductImage } from '../../models';
import { LOYALTY_STATUSES_MAP } from '../constants';

export const convertToProductList = (
  item: SearchedLoyaltyProductViewDto | ViewLoyaltyProduct,
): LoyaltyProgramListProduct => {
  const coverImageId = item.photos?.find(item => item.isCover)?.id ?? item.photos?.[0]?.id;

  const images = [...(item.photos ?? [])].sort((a, b) => (a?.sortOrder ?? 0) - (b?.sortOrder ?? 0));

  return {
    id: item.id,
    // TODO: нужно описание, как вычислять это поле
    isNew: false,
    isFavorite: item.isFavorite,
    status: LOYALTY_STATUSES_MAP[item.status as LoyaltyStatus],
    // @ts-ignore Валера не прописал данное поле в схеме
    createdBy: item['createdBy'],
    name: item.name,
    descriptionShort: item.descriptionShort,
    discountText: item.discountText ?? '',
    sortOrder: item.sortOrder,
    images: images.map<LoyaltyProgramProductImage>(({ id, name, isCover }) => ({ id, file: name ?? '', isCover })),
    coverImageId,
    // TODO: пока не отображаем
    usedCount: undefined,
    contacts: {
      company: {
        id: item.organisationId ?? item.externalOrganisationId,
        parentOrganisationId: item.parentOrganisationId,
        name: item.organisationShortName ?? item.externalOrganisationName ?? '',
        logoId: item.organisationLogoId ?? item.externalOrganisationLogoId,
      },
    },
    unionId: !!item.isAdvertisment ? item.parentOrganisationId : undefined,
    mapObjects: item.mapObjects ?? [],
  };
};
